import { render, staticRenderFns } from "./zone.vue?vue&type=template&id=1ab20e0a&scoped=true"
import script from "./zone.vue?vue&type=script&lang=js"
export * from "./zone.vue?vue&type=script&lang=js"
import style0 from "./zone.vue?vue&type=style&index=0&id=1ab20e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab20e0a",
  null
  
)

export default component.exports